<div class="HeroSection">
    <div class="HeroContainer">
      <app-navbar (languageChanged)="onLanguageChange($event)"></app-navbar>
      <app-header-headline [isEnglish]="isEnglish"></app-header-headline>
      <app-header-banner [isEnglish]="isEnglish"></app-header-banner>
    </div>
  </div>
  